import { createAction } from 'redux-actions'
import {
  GET_DOCUMENT_MONTHLY_STATS,
  GET_DOCUMENT_MONTHLY_STATS_FAILED,
  GET_DOCUMENT_MONTHLY_STATS_SUCCEEDED,
  GET_DOCUMENT_WEEKLY_STATS,
  GET_DOCUMENT_WEEKLY_STATS_FAILED,
  GET_DOCUMENT_WEEKLY_STATS_SUCCEEDED,
} from 'Redux/Types/StatsTypes'

export const getDocumentMonthlyStats = createAction(GET_DOCUMENT_MONTHLY_STATS)
export const getDocumentMonthlyStatsFailed = createAction(GET_DOCUMENT_MONTHLY_STATS_FAILED)
export const getDocumentMonthlyStatsSucceeded = createAction(GET_DOCUMENT_MONTHLY_STATS_SUCCEEDED)

export const getDocumentWeeklyStats = createAction(GET_DOCUMENT_WEEKLY_STATS)
export const getDocumentWeeklyStatsFailed = createAction(GET_DOCUMENT_WEEKLY_STATS_FAILED)
export const getDocumentWeeklyStatsSucceeded = createAction(GET_DOCUMENT_WEEKLY_STATS_SUCCEEDED)
